import React from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

const ProtectedRoute = ({ children, allowedRoles }) => {
  const user = useSelector(
    (state) => state?.auth?.auth?.data?.user
  );

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // If allowedRoles is omitted, authentication is still required.
  // Empty or invalid role lists do not grant access.
  if (
    allowedRoles !== undefined &&
    (
      !Array.isArray(allowedRoles) ||
      !allowedRoles.includes(user.role)
    )
  ) {
    return <Navigate to="/page-error-404" replace />;
  }

  return children;
};

export default ProtectedRoute;